import React from 'react';
import { DateTime } from 'luxon';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';

import { constants } from '../../../config';
import { Product } from '../../../models/Product';
import { ProductHelper } from '../../../helpers/ProductHelper';
import { ComplexRadioBullet } from '../../../common/complex-radio-bullet';
import { GlossaryEntry } from '../../../common/glossary-entry';
import styles from './InstallationLine.css';

const IPropTypes = {
  options: MobxPropTypes.arrayOrObservableArrayOf(PropTypes.shape({
    date: PropTypes.instanceOf(DateTime).isRequired,
    id: PropTypes.string.isRequired,
    startHourString: PropTypes.string.isRequired,
    endHourString: PropTypes.string.isRequired,
  })).isRequired,
  onReject: PropTypes.func,
  // NOTE: for some reason the linter won't pick up this prop
  // even though it's used in the component correctly.
  // eslint-disable-next-line react/no-unused-prop-types
  onSelect: PropTypes.func,
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
    serviceProduct: PropTypes.instanceOf(Product),
  }).isRequired,
};

const defaultProps = {
  onReject: () => {},
  onSelect: () => {},
};

const formatDate = date => (
  `${date.toFormat('cccc d \'de\' MMMM')}`
);

class InstallationLine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedId: null,
      rejected: false,
    };

    this._onRejection = this._onRejection.bind(this);
    this._onSelection = this._onSelection.bind(this);
  }

  _onRejection() {
    this.setState({
      selectedId: null,
      rejected: true,
    });
    this.props.onReject();
  }

  _onSelection(option) {
    this.setState({
      selectedId: option.id,
      rejected: false,
    });
    this.props.onSelect(option);
  }

  render() {
    const installationTexts = ProductHelper
      .findInstallationTextFor(this.props.product.serviceProduct);
    return (
      <div>
        <h2 className={styles.title}>
          {this.props.product.name}
        </h2>
        {
          !!installationTexts &&
          !!installationTexts.length &&
          installationTexts.map(glossaryEntry => (
            <p
              key={glossaryEntry.entries[0].text}
              className={styles.text}
            >
              <GlossaryEntry entry={glossaryEntry} />
            </p>
          ))
        }
        <p className={styles.label}>
          Fecha y hora de servicio
        </p>
        <div>
          {
            this.props.options.map(option => (
              <ComplexRadioBullet
                className={styles.bullet}
                key={option.id}
                topMessage={
                  <p className={styles.topMessage}>
                    {formatDate(option.date)}
                  </p>
                }
                selected={this.state.selectedId === option.id}
                body={
                  <div className={styles.body}>
                    {option.startHourString}hs a {option.endHourString}hs
                  </div>
                }
                onClick={() => this._onSelection(option)}
              />
            ))
          }
          <ComplexRadioBullet
            topMessage={
              <p className={styles.topMessage}>
                Coordinar luego
              </p>
            }
            selected={this.state.rejected}
            onClick={this._onRejection}
          />
        </div>
        <p className={styles.text}>
          Este servicio se realizará en la dirección de entrega de esta compra.
          Si querés realizar la instalación en otra dirección coordiná por teléfono al
          &nbsp;{constants.contactPhoneNumber.text}.
        </p>
        <div className={styles.separator} />
      </div>
    );
  }
}

InstallationLine.propTypes = IPropTypes;
InstallationLine.defaultProps = defaultProps;

export { InstallationLine };



// WEBPACK FOOTER //
// ./src/common/installation-form/installation-line/InstallationLine.jsx